import { render, staticRenderFns } from "./BookingPrestaCancelfees.vue?vue&type=template&id=52cd985a"
import script from "./BookingPrestaCancelfees.vue?vue&type=script&lang=js"
export * from "./BookingPrestaCancelfees.vue?vue&type=script&lang=js"
import style0 from "./BookingPrestaCancelfees.vue?vue&type=style&index=0&id=52cd985a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports